import React from 'react'
import gifweb2 from '../assets/imgs/Nextjsgif.gif'

export const GifwebTwo = () => {
  return (
    <div>
        <img src={gifweb2} alt="gifweb" className="w-full h-full m-3 rounded-md" />
    </div>
  )
}